import { ApiResponse, unwrapResponse } from './api-response';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HostAuthService } from './host-auth.service';
import { ANALYTICS_BASE } from './workforce-api.service';

@Injectable({ providedIn: 'root' })
export class WorkforceAuthGuard implements CanActivate {
  constructor(private http: HttpClient, private router: Router, private auth: HostAuthService) {}

  canActivate(): Observable<boolean | UrlTree> | UrlTree {
    const authorization = this.auth.authorization;
    if (!authorization) return this.loginRoute();

    return this.http.get<ApiResponse<{authenticated: boolean}>>(`${ANALYTICS_BASE}/auth-check`, {
      headers: { Authorization: authorization },
    }).pipe(
      map(body => unwrapResponse(body).authenticated === true ? true : this.loginRoute()),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.clearStaleLogin();
          return of(this.loginRoute());
        }
        if (error.status === 403) return of(this.router.createUrlTree(['/unauth-message']));

        // Let the dashboard show its normal error state for temporary server errors.
        return of(true);
      }),
    );
  }

  private loginRoute(): UrlTree {
    return this.router.createUrlTree(['/login'], {
      queryParams: { returnUrl: '/dashboard' },
    });
  }

  private clearStaleLogin(): void {
    ['accessToken', 'name', 'userName', 'user_type'].forEach((key) => localStorage.removeItem(key));
  }
}
